import {v5 as uuidv5} from 'uuid'

// Check if a value is an object
export const isObject = value => value !== null && typeof value === 'object'

export const padZero = val => {
  return ('' + val).padStart(2, '0')
}

export function getColorTag(currentStatus, shouldApplyColor = true) {
  const errorStatuses = ['cancelled', 'danger', 'processing_failure']
  const successStatuses = ['success', 'completed', 'approved']

  if (shouldApplyColor) {
    if (errorStatuses.includes(currentStatus?.toLocaleLowerCase())) {
      return 'text-red-300 font-bold'
    } else if (successStatuses.includes(currentStatus?.toLocaleLowerCase())) {
      return 'text-green-300 font-bold'
    }
  } else {
    return ''
  }
}

export function getFormattedDate(dateString, timeCheck = false, separator = '/', format = 'dd-mm-yyyy') {
  if (!dateString || dateString == undefined) return '-'
  const dateOnly = dateString?.split('T')[0] ?? dateString
  const date = new Date(dateOnly)
  const locale = navigator.language

  const dateParts = new Intl.DateTimeFormat(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
    .formatToParts(date)
    .reduce((acc, part) => {
      if (part.type === 'day') acc.day = part.value
      if (part.type === 'month') acc.month = part.value
      if (part.type === 'year') acc.year = part.value
      return acc
    }, {})

  const {day = '', month = '', year = ''} = dateParts

  const formatMapping = {
    'dd-mm-yyyy': `${day}${separator}${month}${separator}${year}`,
    'yyyy-dd-mm': `${year}${separator}${day}${separator}${month}`,
    'yyyy-mm-dd': `${year}${separator}${month}${separator}${day}`,
  }

  let formattedDateString = formatMapping[format] || formatMapping['dd-mm-yyyy']

  if (timeCheck) {
    formattedDateString += ` ${new Intl.DateTimeFormat(locale, {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    }).format(date)}`
  }
  return formattedDateString
}

export const getSelectedRowData = (rowSelection = [], records = []) => {
  if (!Array.isArray(rowSelection)) {
    return Object.keys(rowSelection)?.length ? records.filter(record => record && rowSelection[record.id]) : []
  }

  return rowSelection?.map(selection => (selection?.index != null && records ? records[selection.index] : null))
}

export const getFormattedDateString = date => {
  if (date) {
    const formattedDate = new Date(date)
    return formattedDate.toISOString()
  } else {
    return ''
  }
}

export const convertToLowerCase = content => content?.toLowerCase() ?? content

export const copyToClipboard = value => {
  navigator.clipboard.writeText(value).catch(err => {
    console.error('Failed to copy text:', err)
  })
}
export const getISOTimeString = (reqDate, isEndDate = false, isStartDate = false) => {
  if (!reqDate) return
  let date = new Date(reqDate)
  date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
  if (isStartDate) {
    date?.setUTCHours(0, 0, 0, 0)
  }
  if (isEndDate) {
    date?.setUTCHours(23, 59, 59, 999)
  }
  return date.toISOString()
}

export const getDateFromISOString = reqDate => {
  if (!reqDate) return
  const date = new Date(reqDate)
  date.setHours(0, 0, 0)

  return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
}
export const replaceExrtaSpaces = input => {
  if (typeof input !== 'string') {
    return input != null ? String(input) : ''
  }
  return input
    .replace(/&nbsp;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

export const getUUID = (str = 'sales-target', namespace = uuidv5.DNS) => {
  return uuidv5(str, namespace)
}
